/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Construct from 'can/construct/construct';
import can from 'can';
import LocalStorageService from 'scripts/services/localstorage-service';
import FeedService from 'scripts/services/base-feed-service';

const playerFavoritesKey = 'usgaPlayerFavorites';
const qualifyingPlayerFavoritesKey = 'usgaQualifyingPlayerFavorites';
const playerFeedUrl = window.globalSettings.feeds.smt.playerUrl;
const playerListFeedUrl = window.globalSettings.feeds.playerList;

export default Construct.extend(
    {
        init: function() {
            this.favorites = new can.List(
                JSON.parse(
                    LocalStorageService.getItem(playerFavoritesKey) || '[]',
                ),
            );
            this.qualifyingFavorites = new can.List(
                JSON.parse(
                    LocalStorageService.getItem(qualifyingPlayerFavoritesKey) ||
                        '[]',
                ),
            );
        },

        getFavorites() {
            return this.favorites;
        },

        isInFavorites(playerId) {
            return _.includes(this.getFavorites(), playerId);
        },

        getQualifyingFavorites() {
            return this.qualifyingFavorites;
        },

        toggleFavorite(playerId) {
            let index = this.favorites.indexOf(playerId);

            if (index === -1) {
                this.favorites.push(playerId);
            } else {
                this.favorites.splice(index, 1);
            }
            LocalStorageService.setItem(
                playerFavoritesKey,
                this.favorites.attr(),
            );
        },

        toggleQualifyingFavorite(playerId) {
            let index = this.qualifyingFavorites.indexOf(playerId);

            if (index === -1) {
                this.qualifyingFavorites.push(playerId);
            } else {
                this.qualifyingFavorites.splice(index, 1);
            }
            LocalStorageService.setItem(
                qualifyingPlayerFavoritesKey,
                this.qualifyingFavorites.attr(),
            );
        },

        getPlayerInfo(playerId, onDataCb, onFetchingCb, orErrorCb, autoUpdate) {
            const feedService = new FeedService(
                playerFeedUrl,
                true,
                autoUpdate,
            );
            if (onDataCb) {
                feedService.on('data', onDataCb);
            }
            if (onFetchingCb) {
                feedService.on('fetching', onFetchingCb);
            }
            if (orErrorCb) {
                feedService.on('error', orErrorCb);
            }
            feedService.fetch({ identifier: playerId });
        },

        getList(onDataCb, onFetchingCb, orErrorCb) {
            const feedService = new FeedService(playerListFeedUrl, true, false);
            if (onDataCb) {
                feedService.on('data', onDataCb);
            }
            if (onFetchingCb) {
                feedService.on('fetching', onFetchingCb);
            }
            if (orErrorCb) {
                feedService.on('error', orErrorCb);
            }
            feedService.fetch();
        },
    },
    {},
);
